import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { ArticleCtx } from '..';
import { Link } from '@remix-run/react';
const ArticlePoi = (props) => {
    const { buildHref, onPoiClick } = useContext(ArticleCtx);
    const { id, name } = props;
    const href = useMemo(() => buildHref(`/poi/${id}`), [buildHref, id]);
    const handleClick = useCallback((e) => {
        onPoiClick(e, { id });
    }, []);
    return (_jsxs(Link, { className: "l8editor-poi", to: href, onClick: handleClick, children: [_jsx("i", {}), _jsx("span", { children: name })] }));
};
export const ArticlePoiComponentBuilder = (tag, attr) => {
    if (tag === 'a' && attr['class']?.includes('l8editor-poi')) {
        return {
            constructor: ArticlePoi,
            props: {
                name: attr['data-name'],
                id: attr['data-id'],
            },
        };
    }
    return null;
};
